<template>
    <div v-if="error" class="text-center m-3 px-3 rounded border border-danger">
        <p class="d-block invalid-feedback" style="font-size: 1rem">
            {{ $t('error.general') }}
        </p>
    </div>
</template>
<script>
    export default {
        name: 'general-error',
        props: {
            error: {
                type: Boolean,
                required: true,
            },
        }
    };
</script>
